// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton_backButton__7X6Mp","animateIn":"BackButton_animateIn__DRzhl","slideOutFromLogo":"BackButton_slideOutFromLogo__QoYDe","icon":"BackButton_icon__INj25"};